import type { Database } from "../types/supabase.gen";

export type DatabaseDocumentType = Database["public"]["Enums"]["document_type"];

export const DOCUMENT_TYPE_REGISTRY = {
  national_id_card: "admin__identity__id_card",
  passport: "admin__identity__passeport",
  residence_permit: "admin__identity__residence_permit",
  company_remuneration_reference: "admin__company_remuneration_reference",
  professional_card: "professional__professional_card_btp",
  medical_certificate: "admin__health__medical_certificate",
  proof_of_address: "admin__residence__proof_of_address",
  rib: "admin__banking__rib",
  social_security_card: "admin__health_insurance__vital_card",
} satisfies Record<string, DatabaseDocumentType>;

export type DocumentType = keyof typeof DOCUMENT_TYPE_REGISTRY;
export type SupportedDatabaseDocumentType = (typeof DOCUMENT_TYPE_REGISTRY)[DocumentType];

// ===== UTILITIES =====

export function isSupportedDatabaseDocumentType(dbType: DatabaseDocumentType): dbType is SupportedDatabaseDocumentType {
  return Object.values(DOCUMENT_TYPE_REGISTRY).includes(dbType as SupportedDatabaseDocumentType);
}

export function toDatabaseType(type: DocumentType): SupportedDatabaseDocumentType {
  return DOCUMENT_TYPE_REGISTRY[type];
}

type ReversedRegistry = Record<SupportedDatabaseDocumentType, DocumentType>;

export function fromDatabaseType(dbType: SupportedDatabaseDocumentType): DocumentType {
  const registryEntries = Object.entries(DOCUMENT_TYPE_REGISTRY);
  const reversedRegistryEntries = registryEntries.map(([k, v]) => [v, k]);
  const reversedRegistry = Object.fromEntries(reversedRegistryEntries) as ReversedRegistry;
  return reversedRegistry[dbType];
}

function isRegisteredDocumentType(value: string): value is DocumentType {
  return Object.hasOwn(DOCUMENT_TYPE_REGISTRY, value);
}

export const IDENTITY_FRONTEND_DOCUMENT_TYPES: DocumentType[] = Object.keys(DOCUMENT_TYPE_REGISTRY)
  .filter(isRegisteredDocumentType)
  .filter((type) => DOCUMENT_TYPE_REGISTRY[type].startsWith("admin__identity__"));
